// extracted by mini-css-extract-plugin
export default {"container":"SuccessPage_container__03x78","icon":"SuccessPage_icon__nNzfx","header":"SuccessPage_header__CRDGq","text":"SuccessPage_text__MNie7"};